import { cn } from '@/lib/utils';

interface CopyrightProps {
  breakLine?: boolean;
  className?: string;
}

const Copyright = ({ breakLine = true, className }: CopyrightProps) => (
  <div
    className={cn(
      'absolute bottom-3 left-0 w-full text-center text-[12px]',
      className,
    )}
  >
    <a
      href="https://www.mininglamp.com/"
      target="_blank"
      className="!text-[#33333382]"
    >
      Copyright © 2025 北京明略昭辉科技有限公司
    </a>
    {breakLine && <br />}
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      className="!text-[#33333382]"
    >
      京ICP备09014037号-55
    </a>
  </div>
);

export default Copyright;
